import { useEffect, useLayoutEffect, useState } from "react";
import IntelLayout from "@components/layout/layout";
import Header from "./components/Header";
import Panel from "./components/Panel";
import styles from "./LogisticsProfile.module.scss";
import { useLocation, useHistory } from "react-router-dom";
import { getEventName, getUserActivePlan, isProfileAccess } from "@helpers/profileHelper";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { logisticsEvent, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { generateTrackingObject } from "@core/global/global-country-functions";

const LogisticsProfile = () => {
  const [showNotification, setShowNotification] = useState(false);
  const { search: searchUrlParams, pathname } = useLocation();
  const history = useHistory();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");
  const profileName = new URLSearchParams(searchUrlParams).get("profileName");

  useEffect(() => {
    trademoTrackingEvents(getEventName(profileTypeEnum.logistics, logisticsEvent.landing), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
  }, [dataSource, pathname]);

  useLayoutEffect(() => {
    const profileAccess = isProfileAccess(profileName);
    if (!profileAccess?.port) {
      history.push("/sample-logistic-companies");
    }
  }, [profileName, history]);

  return (
    <IntelLayout
      setNotification={(val) => {
        setShowNotification(val);
      }}
      showNotification={showNotification}
      type={"logistics"}>
      <div className={styles.logisticsContainer}>
        <Header />
        <Panel />
      </div>
    </IntelLayout>
  );
};

export default LogisticsProfile;
